import React from 'react';
import QuratorHeader from './QuratorHeader';
import './QuratorLayout.css';

const QuratorLayout = ({ children }) => {
  return (
    <div className="qrt-body">
      <QuratorHeader />
      <main className="qrt-main">
        {children}
      </main>
    </div>
  );
};

export default QuratorLayout;
